import type {SignalToApp} from "@khanacademy/embedded-webapp-schema";

import {couldBeIntegration} from "./could-be-integration.ts";
import {SendQueue} from "./send-queue.ts";

const sendQueue = new SendQueue();

/**
 * Send a message to our integrations, if we're running inside one.
 *
 * This is a no-op when `couldBeIntegration` returns false. When
 * `couldBeIntegration` returns true, this looks for the appropriate messaging
 * system and posts messages to it if it is present; otherwise, it maintains a
 * queue of posted messages and waits for the messaging system to be
 * operational.
 *
 * We maintain this queue because some integrations have bugs, such as on
 * mobile where the messaging system isn't present when the page first loads.
 */
export const sendSignal = (signal: SignalToApp): void => {
    if (!couldBeIntegration()) {
        // We are definitely not in an integration, so do nothing.
        return;
    }

    const message = JSON.stringify(signal);
    sendQueue.postOrQueueMessage(message);
};
